import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { EnvironmentService } from '../../enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ToggleGuardGuard implements CanActivate {
  constructor(
    private envService: EnvironmentService
  ) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const toggle = route.data.toggle;
    if (this.envService.getEnvVar(toggle) === 'true') {
      return true;
    } else {
      return false;
    }
  }
}
